import React, {memo, useState} from 'react';
import './index.scss';
import {onClickHandler} from '../../utils/onclick';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store/reducer';
import { OnboardingModal } from '../OnboardingModal';

type Props = {
    hash: string;
    onKeyPress: (key: string) => void;
    hideCredentials?: boolean;
};

export const Numpad = memo(function Numpad({hash, onKeyPress, hideCredentials = false}: Props) {
    const onboardingList = useSelector((state: ApplicationState) => state.control.onboardingList);
    const showOnboardingButton = onboardingList?.show_onboarding_message;
    const [showOnboardingModal, setShowOnboardingModal] = useState(false);
    
    const handleOnboardingClick = () => {
        setShowOnboardingModal(true);
    };
    const handleCloseOnboardingModal = () => {
        setShowOnboardingModal(false);
    };

    return (
        <div className="keypad-wrapper">
            <div className="keypad">
                <span className="pass-span">{hash}</span>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('1'))}>1</span>
                    <span {...onClickHandler(() => onKeyPress('2'))}>2</span>
                    <span {...onClickHandler(() => onKeyPress('3'))}>3</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('4'))}>4</span>
                    <span {...onClickHandler(() => onKeyPress('5'))}>5</span>
                    <span {...onClickHandler(() => onKeyPress('6'))}>6</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('7'))}>7</span>
                    <span {...onClickHandler(() => onKeyPress('8'))}>8</span>
                    <span {...onClickHandler(() => onKeyPress('9'))}>9</span>
                </div>
                <div className="keypad-row">
                    {!showOnboardingButton && <span className="no-style"></span>}
                    {showOnboardingButton && (
                        <span className="onboarding-button" {...onClickHandler(() => handleOnboardingClick())}>
                            !
                        </span>
                    )}
                    <span {...onClickHandler(() => onKeyPress('0'))}>0</span>
                    <span {...onClickHandler(() => onKeyPress('X'))}>X</span>
                </div>
            </div>
            <OnboardingModal
                isOpen={showOnboardingModal}
                onClose={handleCloseOnboardingModal}
                hideCredentials={hideCredentials}
                onboardingList={onboardingList}
            />
        </div>
    );
});
